var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 380 90",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SuqPOS wordmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 68,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Inter', sans-serif",
    fontSize: 62,
    letterSpacing: -2
  }, /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 700,
    fill: "#32D4E0"
  }, "Suq"), /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 600,
    fill: "#FFB340",
    letterSpacing: -1
  }, "POS"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordmark);
export default __webpack_public_path__ + "static/media/wordmark.657fbe96200a00b269712fec42521e80.svg";
export { ForwardRef as ReactComponent };